import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M7 12H9M11 12H13M16 9.5L18 12L16 14.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
